module.exports = __webpack_public_path__ + "static/media/email.9a0df0bc.svg";